import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Divider from '@mui/material/Divider';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import CSVImport from './CSVImport';

const useStyles = makeStyles()((theme: Theme) => ({
    fields: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        '& .MuiAccordionDetails-root': {
            display: 'block',
        },
    },
    wrapper: {
        marginTop: theme.spacing(2),
    },
}));

function GoogleContactImport() {
    const { classes } = useStyles();

    return (
        <div className={classes.fields}>
            <Accordion>
                <AccordionSummary id="acr_import_csv" expandIcon={<ExpandMoreIcon />}>
                    <Typography component="h3" variant="subtitle1">
                        Import Google CSV
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Divider />
                    <div className={classes.wrapper}>
                        <CSVImport />
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary id="acr_import_google" expandIcon={<ExpandMoreIcon />}>
                    <Typography component="h3" variant="subtitle1">
                        Import Google API
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Divider />
                    <div className={classes.wrapper}>
                        <Typography component="p" variant="body2" align="center">
                            Login
                        </Typography>
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary id="acr_import_zapier" expandIcon={<ExpandMoreIcon />}>
                    <Typography component="h3" variant="subtitle1">
                        Zapier Docs Import
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Divider />
                    <div className={classes.wrapper}></div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default GoogleContactImport;
